import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
// Remover: import { createClient } from '@supabase/supabase-js';
import claqueteImg from '../assets/img/claquete.png';

const ColetivasPageContainer = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
`;

const Header = styled.header`
  background: #ba3b3b;
  color: #f0eadd;
  padding: 40px 0;
  text-align: center;
`;

const HeaderTitle = styled.h1`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 48px;
  font-weight: bold;
  margin: 0 0 20px 0;
`;

const HeaderSubtitle = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 18px;
  margin: 0;
  opacity: 0.9;
`;



const Content = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
`;

const LoadingContainer = styled.div`
  text-align: center;
  padding: 60px 20px;
`;

const LoadingText = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 24px;
  color: #333;
`;

const ErrorContainer = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 8px;
  margin: 20px 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
`;

const ErrorText = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 18px;
  color: #d32f2f;
`;

const ColetivasGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 40px;
  align-items: stretch;
`;

const ColetivaCard = styled.article`
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0,0,0,0.15);
  }
`;

const ColetivaHeader = styled.div`
  background: #ba3b3b;
  color: #f0eadd;
  padding: 20px 25px 25px 25px;
  flex-shrink: 0;
`;

const ColetivaTitle = styled.h2`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
  text-align: center;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ColetivaContent = styled.div`
  padding: 25px;
  line-height: 1.6;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const ColetivaText = styled.div`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #333;
  line-height: 1.7;
  max-height: 200px;
  overflow: hidden;
  position: relative;
  flex: 1;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: linear-gradient(transparent, rgba(255, 255, 255, 0.8), #fff);
    pointer-events: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'League Spartan', Arial, Helvetica, sans-serif;
    color: #ba3b3b;
    margin: 20px 0 10px 0;
  }

  h1 { font-size: 24px; }
  h2 { font-size: 22px; }
  h3 { font-size: 20px; }
  h4 { font-size: 18px; }
  h5 { font-size: 16px; }
  h6 { font-size: 14px; }

  p {
    margin: 0 0 15px 0;
  }

  ul, ol {
    margin: 15px 0;
    padding-left: 20px;
  }

  li {
    margin: 5px 0;
  }

  strong, b {
    font-weight: bold;
    color: #ba3b3b;
  }

  em, i {
    font-style: italic;
  }

  blockquote {
    border-left: 4px solid #ba3b3b;
    padding-left: 20px;
    margin: 20px 0;
    font-style: italic;
    color: #666;
  }

  a {
    color: #ba3b3b;
    text-decoration: underline;
    
    &:hover {
      color: #8b2a2a;
    }
  }

  &.expanded {
    max-height: none;
    
    &::after {
      display: none;
    }
  }
`;

const ReadMoreButton = styled.button`
  background: transparent;
  color: #ba3b3b;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  border: none;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
  position: relative;
  z-index: 1;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: #8b2a2a;
    text-decoration-thickness: 2px;
  }
`;

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const DialogContent = styled.div`
  background: #fff;
  border-radius: 12px;
  max-width: 800px;
  width: 100%;
  max-height: 80vh;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
`;

const DialogHeader = styled.div`
  background: #ba3b3b;
  color: #f0eadd;
  padding: 25px;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
  z-index: 10;
`;

const DialogTitle = styled.h2`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 10px 0;
  line-height: 1.2;
`;

const DialogBody = styled.div`
  padding: 30px;
  overflow-y: auto;
  flex: 1;
`;

const DialogText = styled.div`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #333;
  line-height: 1.7;

  h1, h2, h3, h4, h5, h6 {
    font-family: 'League Spartan', Arial, Helvetica, sans-serif;
    color: #ba3b3b;
    margin: 20px 0 10px 0;
  }

  h1 { font-size: 24px; }
  h2 { font-size: 22px; }
  h3 { font-size: 20px; }
  h4 { font-size: 18px; }
  h5 { font-size: 16px; }
  h6 { font-size: 14px; }

  p {
    margin: 0 0 15px 0;
  }

  ul, ol {
    margin: 15px 0;
    padding-left: 20px;
  }

  li {
    margin: 5px 0;
  }

  strong, b {
    font-weight: bold;
    color: #ba3b3b;
  }

  em, i {
    font-style: italic;
  }

  blockquote {
    border-left: 4px solid #ba3b3b;
    padding-left: 20px;
    margin: 20px 0;
    font-style: italic;
    color: #666;
  }

  a {
    color: #ba3b3b;
    text-decoration: underline;
    
    &:hover {
      color: #8b2a2a;
    }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -20px;
  right: -20px;
  background: #222;
  color: #f0eadd;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #444;
  }
`;

const DialogFooter = styled.div`
  background: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  padding: 20px 25px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
  min-height: 80px;
  box-sizing: border-box;
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
`;

const ColetivaFooter = styled.div`
  background: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  padding: 20px 25px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
  height: 80px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const WriterInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 100%;
`;

const WriterAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ba3b3b;
`;

const WriterDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const WriterName = styled.span`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #ba3b3b;
  line-height: 1.2;
`;

const WriterLabel = styled.span`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ColetivaDate = styled.div`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  color: #666;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 2px;
`;

const DateMain = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const DateYear = styled.span`
  font-size: 12px;
  opacity: 0.7;
`;

const HeaderRatingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 15px;
  margin-bottom: 10px;
`;

const ClaquetesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const Claquete = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

const ClaqueteHalf = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  overflow: hidden;
`;

const ClaqueteHalfImg = styled.img`
  width: 40px;
  height: 20px;
  object-fit: contain;
  position: absolute;
  left: -20px;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
`;

const EmptyText = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 20px;
  color: #666;
  margin: 0;
`;

const ColetivasPage = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedColetiva, setSelectedColetiva] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Chamada para o Worker em vez do Supabase diretamente
        const response = await fetch('/api/coletivas');
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.error) {
          setError(new Error(data.error));
        } else {
          setData(data);
          console.log('Coletivas carregadas com writers:', data);
        }
      } catch (err) {
        setError(err);
        console.error('Erro ao carregar coletivas:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Função para renderizar HTML de forma segura
  const renderHTML = (htmlContent) => {
    if (!htmlContent) return '';
    
    // Sanitização básica - remove scripts e outros elementos perigosos
    const sanitizedHTML = htmlContent
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
      .replace(/javascript:/gi, '')
      .replace(/on\w+\s*=/gi, '');
    
    return { __html: sanitizedHTML };
  };

  // Função para formatar data
  const formatDate = (dateString) => {
    if (!dateString) return { main: '', year: '' };
    const date = new Date(dateString);
    const main = date.toLocaleDateString('pt-BR', {
      month: 'long',
      day: 'numeric'
    });
    const year = date.getFullYear().toString();
    return { main, year };
  };

  // Função para abrir dialog
  const openDialog = (coletiva) => {
    setSelectedColetiva(coletiva);
    setIsDialogOpen(true);
  };

  // Função para fechar dialog
  const closeDialog = () => {
    setIsDialogOpen(false);
    setSelectedColetiva(null);
  };

  // Função para verificar se o texto precisa ser truncado
  const needsTruncation = (text) => {
    if (!text) return false;
    // Estimativa simples baseada no número de caracteres
    const textLength = text.replace(/<[^>]*>/g, '').length;
    return textLength > 300; // Aproximadamente 300 caracteres
  };

  // Função para converter nota de 1-10 para 1-5
  const convertRating = (rate) => {
    if (!rate || rate < 1 || rate > 10) return 0;
    return rate / 2;
  };

  // Função para renderizar claquetes
  const renderClaquetes = (rating) => {
    const convertedRating = convertRating(rating);
    if (convertedRating === 0) return null;

    const fullClaquetes = Math.floor(convertedRating);
    const hasHalf = convertedRating % 1 !== 0;
    const claquetes = [];

    // Adiciona claquetes completas
    for (let i = 0; i < fullClaquetes; i++) {
      claquetes.push(
        <Claquete key={`full-${i}`} src={claqueteImg} alt="Claquete" />
      );
    }

    // Adiciona meia claquete se necessário
    if (hasHalf) {
      claquetes.push(
        <ClaqueteHalf key="half">
          <ClaqueteHalfImg src={claqueteImg} alt="Meia claquete" />
        </ClaqueteHalf>
      );
    }

    return claquetes;
  };

  if (loading) {
    return (
      <ColetivasPageContainer>
        <Header>
          <HeaderTitle>Coletivas e Entrevistas</HeaderTitle>
          <HeaderSubtitle>Conversas e encontros com personalidades do entretenimento</HeaderSubtitle>
        </Header>
        <LoadingContainer>
          <LoadingText>Carregando coletivas...</LoadingText>
        </LoadingContainer>
      </ColetivasPageContainer>
    );
  }

  if (error) {
    return (
      <ColetivasPageContainer>
        <Header>
          <HeaderTitle>Coletivas e Entrevistas</HeaderTitle>
          <HeaderSubtitle>Conversas e encontros com personalidades do entretenimento</HeaderSubtitle>
        </Header>
        <ErrorContainer>
          <ErrorText>Erro ao carregar as coletivas. Tente novamente mais tarde.</ErrorText>
        </ErrorContainer>
      </ColetivasPageContainer>
    );
  }

  return (
    <ColetivasPageContainer>
      <Header>
        <HeaderTitle>Coletivas e Entrevistas</HeaderTitle>
        <HeaderSubtitle>Conversas e encontros com personalidades do entretenimento</HeaderSubtitle>
      </Header>
      <Content>
        {!data || data.length === 0 ? (
          <EmptyState>
            <EmptyText>Nenhuma coletiva encontrada no momento.</EmptyText>
          </EmptyState>
        ) : (
          <ColetivasGrid>
                         {data.map((coletiva, index) => (
                               <ColetivaCard key={coletiva.id || index}>
                  <ColetivaHeader>
                    <ColetivaTitle>{coletiva.title || 'Coletiva sem título'}</ColetivaTitle>
                  </ColetivaHeader>
                  <ColetivaContent>
                    {coletiva.rate && (
                      <HeaderRatingContainer>
                        <ClaquetesContainer>
                          {renderClaquetes(coletiva.rate)}
                        </ClaquetesContainer>
                        <span style={{ fontSize: '14px', color: '#666', marginLeft: '8px' }}>
                          ({convertRating(coletiva.rate)}/5)
                        </span>
                      </HeaderRatingContainer>
                    )}
                    <ColetivaText 
                      dangerouslySetInnerHTML={renderHTML(coletiva.text)}
                    />
                    {needsTruncation(coletiva.text) && (
                      <ReadMoreButton onClick={() => openDialog(coletiva)}>
                        Ler mais
                      </ReadMoreButton>
                    )}
                  </ColetivaContent>
                 <ColetivaFooter>
                   <WriterInfo>
                     {coletiva.writers && coletiva.writers.photo_url && (
                       <WriterAvatar 
                         src={coletiva.writers.photo_url} 
                         alt={coletiva.writers.name || 'Avatar do autor'}
                         onError={(e) => {
                           e.target.style.display = 'none';
                         }}
                       />
                     )}
                     <WriterDetails>
                       <WriterLabel>Por</WriterLabel>
                       <WriterName>
                         {coletiva.writers ? coletiva.writers.name : 'Autor desconhecido'}
                       </WriterName>
                     </WriterDetails>
                   </WriterInfo>
                                       <ColetivaDate>
                      {coletiva.created_at && (() => {
                        const dateInfo = formatDate(coletiva.created_at);
                        return (
                          <>
                            <DateMain>{dateInfo.main}</DateMain>
                            <DateYear>{dateInfo.year}</DateYear>
                          </>
                        );
                      })()}
                    </ColetivaDate>
                 </ColetivaFooter>
               </ColetivaCard>
             ))}
          </ColetivasGrid>
        )}
      </Content>
      
      {/* Dialog para texto completo */}
      {isDialogOpen && selectedColetiva && (
                 <DialogOverlay onClick={closeDialog}>
           <DialogContent onClick={(e) => e.stopPropagation()}>
             <DialogHeader>
               <DialogTitle>{selectedColetiva.title || 'Coletiva sem título'}</DialogTitle>
               <CloseButton onClick={closeDialog}>×</CloseButton>
             </DialogHeader>
             <DialogBody>
               {selectedColetiva.rate && (
                 <HeaderRatingContainer style={{ marginBottom: '20px' }}>
                   <ClaquetesContainer>
                     {renderClaquetes(selectedColetiva.rate)}
                   </ClaquetesContainer>
                   <span style={{ fontSize: '16px', color: '#666', marginLeft: '8px' }}>
                     ({convertRating(selectedColetiva.rate)}/5)
                   </span>
                 </HeaderRatingContainer>
               )}
               <DialogText 
                 dangerouslySetInnerHTML={renderHTML(selectedColetiva.text)}
               />
             </DialogBody>
             <DialogFooter>
               <WriterInfo>
                 {selectedColetiva.writers && selectedColetiva.writers.photo_url && (
                   <WriterAvatar 
                     src={selectedColetiva.writers.photo_url} 
                     alt={selectedColetiva.writers.name || 'Avatar do autor'}
                     onError={(e) => {
                       e.target.style.display = 'none';
                     }}
                   />
                 )}
                 <WriterDetails>
                   <WriterLabel>Por</WriterLabel>
                   <WriterName>
                     {selectedColetiva.writers ? selectedColetiva.writers.name : 'Autor desconhecido'}
                   </WriterName>
                 </WriterDetails>
               </WriterInfo>
               <ColetivaDate>
                 {selectedColetiva.created_at && (() => {
                   const dateInfo = formatDate(selectedColetiva.created_at);
                   return (
                     <>
                       <DateMain>{dateInfo.main}</DateMain>
                       <DateYear>{dateInfo.year}</DateYear>
                     </>
                   );
                 })()}
               </ColetivaDate>
             </DialogFooter>
           </DialogContent>
         </DialogOverlay>
      )}
    </ColetivasPageContainer>
  );
};

export default ColetivasPage;
